// eslint-disable-next-line fsd/layer-imports
import { useProfile } from '@/entities/profile'

import { useActivityTracking } from './useActivityTracking'
import { useAmplitude } from './useAmplitude'

export const useNewsTracking = () => {
  const { profile } = storeToRefs(useProfile())
  const { track } = useAmplitude()
  const { updateActivity } = useActivityTracking()

  const trackNewsOpened = (newsId: number, source = 'news_list') => {
    if (!profile.value) {
      return
    }

    track('news_opened', {
      user_id: profile.value.id,
      news_id: newsId,
      timestamp: Date.now(),
      source,
      user_role: profile.value.role,
      department: profile.value.department?.name || 'unassigned',
    })

    updateActivity(`news_opened_${newsId}`)
  }

  const trackNewsLike = (newsId: number, isLiked: boolean, previousLikesCount: number) => {
    if (!profile.value) {
      return
    }

    track('news_like', {
      user_id: profile.value.id,
      news_id: newsId,
      timestamp: Date.now(),
      action: isLiked ? 'like' : 'unlike',
      likes_count_after: isLiked ? previousLikesCount + 1 : previousLikesCount - 1,
      user_role: profile.value.role,
      department: profile.value.department?.name || 'unassigned',
    })

    updateActivity(`news_${isLiked ? 'liked' : 'unliked'}_${newsId}`)
  }

  const trackNewsListViewed = (totalCount: number, searchQuery?: string) => {
    if (!profile.value) {
      return
    }

    track('news_list_viewed', {
      user_id: profile.value.id,
      timestamp: Date.now(),
      total_news_count: totalCount,
      search_query: searchQuery || null,
      user_role: profile.value.role,
      department: profile.value.department?.name || 'unassigned',
    })

    updateActivity('news_list_viewed')
  }

  const trackNewsSearch = (searchQuery: string, resultsCount: number) => {
    if (!profile.value) {
      return
    }

    track('news_search', {
      user_id: profile.value.id,
      timestamp: Date.now(),
      search_query: searchQuery,
      results_count: resultsCount,
      user_role: profile.value.role,
      department: profile.value.department?.name || 'unassigned',
    })

    updateActivity(`news_search_${searchQuery}`)
  }

  return {
    trackNewsOpened,
    trackNewsLike,
    trackNewsListViewed,
    trackNewsSearch,
  }
}
